// constants
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
import { vtm } from "../../App.js";

import { fetchData } from "../data/dataActions";
import App from "../../App";

const connectRequest = () => {
  return {
    type: "CONNECTION_REQUEST",
  };
};

const connectSuccess = (payload) => {
  return {
    type: "CONNECTION_SUCCESS",
    payload: payload,
  };
};

const connectFailed = (payload) => {
  return {
    type: "CONNECTION_FAILED",
    payload: payload,
  };
};

const updateAccountRequest = (payload) => {
  return {
    type: "UPDATE_ACCOUNT",
    payload: payload,
  };
};

export const connect = () => {
  return async (dispatch) => {
    dispatch(connectRequest());


    const TokenabiResponse = await fetch("/config/Tokenabi.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });


    const Tokenabi = await TokenabiResponse.json();
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });



    const CONabiResponse = await fetch("/config/CONabi.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const CONabi = await CONabiResponse.json();

    const PANabiResponse = await fetch("/config/PANabi.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const PANabi = await PANabiResponse.json();




















    const CONFIG = await configResponse.json();

    const { ethereum } = window;
    const metamaskIsInstalled = ethereum && ethereum.isMetaMask;
if (metamaskIsInstalled) 
  {
    Web3EthContract.setProvider(ethereum);
    let web3 = new Web3(ethereum);
    try 
    {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });
        const networkId = await ethereum.request({
          method: "net_version",
        });


        if (networkId == CONFIG.NETWORK2.ID) 
        {
          const SmartContractObj = new Web3EthContract(Tokenabi, CONFIG.B_TOKEN_ADDRESS);
          const SmartContractObj2 = new Web3EthContract(CONabi, CONFIG.B_CONTRACT_ADDRESS);
          const SmartContractObj3 = new Web3EthContract(PANabi, CONFIG.B_CONTRACT_ADDRESS2);
          dispatch
            (
              connectSuccess
                ({
                  account: accounts[0],
                  smartContract: SmartContractObj,
                  smartContract2: SmartContractObj2,
                  smartContract3: SmartContractObj3,
                  web3: web3,
                  chainID: networkId,
                  Con: CONFIG.B_CONTRACT_ADDRESS,
                  Pan: CONFIG.B_CONTRACT_ADDRESS2,
                  Tok: CONFIG.B_TOKEN_ADDRESS,
                  link: CONFIG.OFX_BUYB,
                  logo: CONFIG.BLOGO,
                })

            );

          // Add listeners start
          ethereum.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });
        }


      /*  else if (networkId == CONFIG.NETWORK3.ID) 
        {
          const SmartContractObj = new Web3EthContract(Tokenabi, CONFIG.P_TOKEN_ADDRESS);
          const SmartContractObj2 = new Web3EthContract(CONabi, CONFIG.P_CONTRACT_ADDRESS);
          const SmartContractObj3 = new Web3EthContract(PANabi, CONFIG.P_CONTRACT_ADDRESS2);
          dispatch
            (
              connectSuccess
                ({
                  account: accounts[0],
                  smartContract: SmartContractObj,
                  smartContract2: SmartContractObj2,
                  smartContract3: SmartContractObj3,
                  web3: web3,
                  chainID: networkId,
                  Con: CONFIG.P_CONTRACT_ADDRESS,
                  Pan: CONFIG.P_CONTRACT_ADDRESS2,
                  Tok: CONFIG.P_TOKEN_ADDRESS,
                  link: CONFIG.OFX_BUY,
                  logo: CONFIG.PLOGO,
                })

            );

          // Add listeners start
          ethereum.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });
        }*/

        else if (networkId == CONFIG.NETWORK4.ID) 
        {
          const SmartContractObj = new Web3EthContract(Tokenabi, CONFIG.T_TOKEN_ADDRESS);
          const SmartContractObj2 = new Web3EthContract(CONabi, CONFIG.T_CONTRACT_ADDRESS);
          const SmartContractObj3 = new Web3EthContract(PANabi, CONFIG.T_CONTRACT_ADDRESS2);
          dispatch
            (
              connectSuccess
                ({
                  account: accounts[0],
                  smartContract: SmartContractObj,
                  smartContract2: SmartContractObj2,
                  smartContract3: SmartContractObj3,
                  web3: web3,
                  chainID: networkId,
                  Con: CONFIG.T_CONTRACT_ADDRESS,
                  Pan: CONFIG.T_CONTRACT_ADDRESS2,
                  Tok: CONFIG.T_TOKEN_ADDRESS,
                  link: CONFIG.OFX_BUY,
                  logo: CONFIG.ELOGO,
                })

            );

          // Add listeners start
          ethereum.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });
        }
      
       /* else if (networkId == CONFIG.NETWORK1.ID) 
        {
          const SmartContractObj = new Web3EthContract(Tokenabi, CONFIG.E_TOKEN_ADDRESS);
          const SmartContractObj2 = new Web3EthContract(CONabi, CONFIG.E_CONTRACT_ADDRESS);
          const SmartContractObj3 = new Web3EthContract(PANabi, CONFIG.E_CONTRACT_ADDRESS2);
          dispatch
            (
              connectSuccess
                ({
                  account: accounts[0],
                  smartContract: SmartContractObj,
                  smartContract2: SmartContractObj2,
                  smartContract3: SmartContractObj3,
                  web3: web3,
                  chainID: networkId,
                  Con: CONFIG.E_CONTRACT_ADDRESS,
                  Pan: CONFIG.E_CONTRACT_ADDRESS2,
                  Tok: CONFIG.E_TOKEN_ADDRESS,
                  link: CONFIG.OFX_BUY,
                  logo: CONFIG.ELOGO,
                })

            );

          // Add listeners start
          ethereum.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });
          // Add listeners end
        }*/
        else 
        {
          dispatch(connectFailed(`Switch to ${CONFIG.NETWORK2.NAME} or ${CONFIG.NETWORK4.NAME}. Other chains coming soon.`));
        }






        
    }
      catch (err) 
      {
        dispatch(connectFailed("Something went wrong."));
      }
} else 
  {
  dispatch(connectFailed("Install Metamask."));
  }
  };
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account: account }));
    dispatch(fetchData(account));
  };
};
